import React, { useState, useContext } from 'react';

import './Footer.css';

import { Link } from 'react-router-dom';

import { FaLocationDot, FaPhone, FaEnvelope, FaRegCopyright, FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaYoutube, FaPaperPlane } from 'react-icons/fa6';

import { LanguageContext, getTranslation } from '../LanguageContext';

import logo from "../image/logo.png";



// ترجمات خاصة بمكون التذييل

const footerTranslations = {

  en: {

    about: "About Us",

    aboutDesc: "National Association for Child Protection is a non-profit organization dedicated to ensuring the safety, well-being, and healthy development of children.",

    quickLinks: "Quick Links",

    home: "Home",

    history: "History",

    news: "News",

    contact: "Contact",

    resources: "Resources",

    media: "Media Library",

    gallery: "Photo Gallery",

    videos: "Videos",

    audio: "Audio",

    helpCenter: "Help Center",

    makeImpact: "Make an Impact",

    donate: "Donate",

    volunteer: "Volunteer",

    contactUs: "Contact Us",

    address: "Address",

    addressText: "195 bd moufdi zakaria hay almouna Berrechid - Maroc",

    phone: "Phone",

    email: "Email",

    subscribe: "Subscribe to our newsletter",

    subscribeDesc: "Get the latest news and updates delivered straight to your inbox",

    emailPlaceholder: "Your email address",

    subscribeBtn: "Subscribe",

    thanks: "Thank you for subscribing!",

    copyright: "Copyright",

    rights: "All Rights Reserved",

    privacy: "Privacy Policy",

    terms: "Terms of Service",

    followUs: "Follow Us"

  },

  fr: {

    about: "À Propos",

    aboutDesc: "Tout savoir sur la protection de l'enfance au Maroc",

    quickLinks: "Liens Rapides",

    home: "Page d'accueil",

    history: "Histoire",

    news: "Nouvelles",

    contact: "Contact",

    resources: "Ressources",

    media: "Médiathèque",

    gallery: "Galerie Photos",

    videos: "Vidéos",

    audio: "Audio",

    helpCenter: "Centre d'Aide",

    makeImpact: "Faire un Impact",

    donate: "Donner",

    volunteer: "Bénévolat",

    contactUs: "Contactez-nous",

    address: "Adresse",

    addressText: "195 bd moufdi zakaria hay almouna Berrechid - Maroc",

    phone: "Téléphone",

    email: "E-mail",

    subscribe: "Abonnez-vous à notre newsletter",

    subscribeDesc: "Recevez les dernières nouvelles et mises à jour directement dans votre boîte de réception",

    emailPlaceholder: "Votre adresse e-mail",

    subscribeBtn: "S'abonner",

    thanks: "Merci de vous être abonné!",

    copyright: "Droits d'auteur",

    rights: "Tous Droits Réservés",

    privacy: "Politique de Confidentialité",

    terms: "Conditions d'Utilisation",

    followUs: "Suivez-nous"

  },

  ar: {

    about: "من نحن",

    aboutDesc: "حماية اطفالكم أولويتنا",

    quickLinks: "روابط سريعة",

    home: "الصفحة الرئيسية",

    history: "تاريخنا",

    news: "أخبار",

    contact: "اتصل بنا",

    resources: "موارد",

    media: "مكتبة الوسائط",

    gallery: "معرض الصور",

    videos: "الفيديوهات",

    audio: "الصوتيات",

    helpCenter: "مركز المساعدة",

    makeImpact: "أحدث تأثيرًا",

    donate: "تبرع",

    volunteer: "تطوع",

    contactUs: "اتصل بنا",

    address: "العنوان",

    addressText: "١٩٥ شارع موفدي زكريا حي المونة بن رشيد - المغرب",

    phone: "الهاتف",

    email: "البريد الإلكتروني",

    subscribe: "اشترك في نشرتنا الإخبارية",

    subscribeDesc: "احصل على آخر الأخبار والتحديثات مباشرة في صندوق البريد الخاص بك",

    emailPlaceholder: "عنوان بريدك الإلكتروني",

    subscribeBtn: "اشترك",

    thanks: "شكرا على اشتراكك!",

    copyright: "حقوق النشر",

    rights: "جميع الحقوق محفوظة",

    privacy: "سياسة الخصوصية",

    terms: "شروط الخدمة",

    followUs: "تابعنا"

  }

};



const Footer = () => {

  const [email, setEmail] = useState('');

  const [subscribeAnimation, setSubscribeAnimation] = useState(false);

  

  // استخدام سياق اللغة

  const { language } = useContext(LanguageContext);

  

  // دالة للحصول على الترجمة

  const translate = (key) => getTranslation(footerTranslations, language, key);



  const handleSubscribe = (e) => {

    e.preventDefault();

    setSubscribeAnimation(true);

    setTimeout(() => setSubscribeAnimation(false), 2000);

    console.log('Subscribed email:', email);

    setEmail('');

  };



  // تحديد إذا كان الاتجاه من اليمين إلى اليسار

  const isRTL = language === 'ar';

  

  const currentYear = new Date().getFullYear();

  

  return (

    <div className={`footer-container ${isRTL ? 'rtl' : ''}`}>

      {/* محتوى التذييل الرئيسي */}

      <div className="footer-main">

        <div className="footer-content">

          {/* شعار ومعلومات عنا */}

          <div className="footer-section about-section">

            <div className="footer-logo">

              <img src={logo} alt="ANPE Logo" />

            </div>

            <h3 className="footer-title">{translate('about')}</h3>

            <p className="footer-text">{translate('aboutDesc')}</p>

          </div>



          {/* روابط سريعة */}

          <div className="footer-section links-section">

            <h3 className="footer-title">{translate('quickLinks')}</h3>

            <ul className="footer-links">

              <li><Link to="/">{translate('home')}</Link></li>

              <li><a href="#about">{translate('history')}</a></li>

              <li><a href="#nouvelles">{translate('news')}</a></li>

              <li><Link to="/contact">{translate('contact')}</Link></li>

            </ul>

            <Link to="/donner" className="donate-button">

              {translate('donate')}

            </Link>

          </div>



          {/* معلومات الاتصال */}

          <div className="footer-section contact-section">

            <h3 className="footer-title">{translate('contactUs')}</h3>

            <ul className="contact-info">

              <li>

                <FaLocationDot className="contact-icon" />

                <span>{translate('addressText')}</span>

              </li>

              <li>

                <FaPhone className="contact-icon" />

                <span>+2126 06 71 3477</span>

              </li>

              <li>

                <FaEnvelope className="contact-icon" />

                <span>anpemaroc@gmail.com</span>

              </li>

            </ul>

          </div>

        </div>

      </div>



      {/* أسفل التذييل */}

      <div className="footer-bottom">

        <div className="footer-bottom-content">

          <p className="copyright">

            <FaRegCopyright /> {currentYear} ANPE - {translate('rights')}

          </p>

          <div className="social-links">

            <a href="https://twitter.com/LAHLOU42?t=CtQr8Ve2NtTymx8d5mQXDA&s=09" target="_blank" rel="noopener noreferrer" className="social-link">

              <FaTwitter />

            </a>

            <a href="https://www.facebook.com/groups/protection.enfants/?_rdc=1&_rdr" target="_blank" rel="noopener noreferrer" className="social-link">

              <FaFacebook />

            </a>

            <a href="https://www.instagram.com/lahlouazarabe/?igshid=ZDdkNTZiNTM%3D" target="_blank" rel="noopener noreferrer" className="social-link">

              <FaInstagram />

            </a>

            <a href="https://www.linkedin.com/in/azarabe-lahlou-73511027/?originalSubdomain=fr" target="_blank" rel="noopener noreferrer" className="social-link">

              <FaLinkedin />

            </a>

            <a href="https://www.youtube.com/@associationanpe5996" target="_blank" rel="noopener noreferrer" className="social-link youtube-link">

              <FaYoutube />

            </a>

          </div>

          <div className="footer-legal">

            <Link to="/privacy">{translate('privacy')}</Link>

            <Link to="/terms">{translate('terms')}</Link>

          </div>

        </div>

      </div>

    </div>

  );

};



export default Footer;